import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { CreateOrder, extendCoupon, extendDetails, extendFinalSubmit, extendPreSubmit, getCountryStateCityData, getCountryStateCityList, getcoupons, getExtensionList, getOrder, getSubscriptionDetail, getSubscriptionList, preSubmitPackage, submitPackage } from "../../restApi/api";
import { decrypt } from "../../utils/crypto";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import Modal from "react-bootstrap/Modal";
import { authorizationCheck } from "../../utils/logout";

// import Razorpay from 'razorpay';

const INITIAL_STATE = {
    colonyArea: '',
    city: '',
    country: '',
    flateNumber: '',
    landmark: '',
    pincode: '',
    state: '',
};
export default function PlanExtention() {
    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    const navigate = useNavigate();
    let location = useLocation();
    const [orderShow, setOrder] = useState(false);
    const orderInfo = () => setOrder(true);
    const orderHide = () => setOrder(false);
    const [country, setCountry] = useState(null);
    const [coupon, setCoupon] = useState('');
    const [state, setState] = useState(null);
    const [city, setCity] = useState(null);
    const [countryId, setcountryId] = useState(null);
    const [stateId, setStateId] = useState(null);
    const [cityId, setCityId] = useState(null);
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [getProfileDetails, profileDetails] = useState(INITIAL_STATE);
    const [packId, setpackId] = useState(JSON.parse(location.state))
    const [ind, setIndex] = useState(0);
    const [alldata, setAllData] = useState([]);
    const [subscription, setSubscription] = useState([]);
    const [term, setTerm] = useState();
    const [validity, setValidity] = useState();
    const [packages, setPackage] = useState(false);
    const [TotalAmount, setAmount] = useState(0)
    let [paymentDetail, setpaymentDetail] = useState({});
    const [packagekey, setpackagekey] = useState(1);
    const [Price, settotalprice] = useState(0)
    const [couponshow, setCouponshow] = useState(0)
    const [redeemshow, setredeemshow] = useState(0)
    let [count, setCount] = useState(0);
    let [isBillingRequired, setIsBillingRequired] = useState(false);
    let [isCouponRequired, setIsCouponRequired] = useState(false);

    let Billingcity = ''
    let Billingstate = ''
    let BillingCountry = ''
    let index = 0
    let totalprice = 0
    let packagePrice = 0
    let redeem = parseInt(0)
    let couponPrice = 0
    let discountPercentage = 0
    let redeemShow = true


    const showToast = (message) => {
        toast.success(message);
    };

    const showToastError = (message) => {
        toast.error(message);
    };

    useEffect(() => {
        setSubscription(packId)
        console.log(packId);
        setIsBillingRequired(packId && packId?.isAddressMandatory ? true : false)
        index = 0
        setIndex(0)
        setPackage(true)
        setValidity(packId?.packageExtension?.validity[0])
        calculatePrice(packId?.packageExtension?.validity[0])
    }, [])

    const termList = async () => {
        let data = {}
        await extendDetails(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let req = JSON.parse(decrypt(data))
                if (req.data.code == 1) {
                    setTerm(req.data.result)
                }
                else if (req.data.code == 402) {
                    authorizationCheck(navigate)
                }
            })
    }
    const makeApiCall = () => {
        const data = {
            "orderId": paymentDetail?.notes?.orderId
        }
        getOrder(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.success == true) {
                    if (data.data.transactionStatus == 'COMPLETED') {
                        navigate(`/success/${packId?.title}/${validity?.number + validity?.vtype}`)
                    }
                    else if (data.data.transactionStatus == 'PENDING' || data.data.transactionStatus == 'INITIATED') {
                        var intervalId
                        if (count < 1) {
                            makeApiCall()
                            count = count + 1
                            setCount(count + 1)
                        } else {
                            intervalId = setInterval(makeApiCall, 1000);
                            clearInterval(intervalId); // Stop the interval
                            navigate('/pending')
                        }
                    }
                    else {
                        navigate('/error')
                    }
                }

            }).catch((error) => {
                showToastError("Something went wrong please try agian")
            })
    }
    const choosePackage = (e, i, ob) => {
        setValidity(ob)
        setPackage(e.target.checked)
        index = i
        setIndex(i)
        discountPercentage = 0
        setpackagekey(1)
        setCoupon('')
        calculatePrice(ob)
    }
    const handleInputChange = function (fieldValue, fieldName) {
        profileDetails({ ...getProfileDetails, [fieldName]: fieldValue })
    }
    const getCountry = async () => {
        const data = {
            "country": "",
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityData(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setCountry(data)
                setState('')
                setCity('')
            })
    }

    const selectCountry = async (slctCountry) => {
        profileDetails({
            ...getProfileDetails,
            country: slctCountry ? slctCountry.target.value : countryId
        })
        const data = {
            "country": slctCountry ? slctCountry.target.value : countryId,
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.states) {
                    setState(data)
                    setCity(null)
                    return
                }
                setState(null)
                setCity(null)
                return
                // setState(data)
                // setStateId(data.data.result.states[0]._id)
            })
    }

    const selectState = async (slctState) => {
        profileDetails({
            ...getProfileDetails,
            state: slctState ? slctState.target.value : stateId
        })
        const data = {
            "country": "",
            "state": slctState ? slctState.target.value : stateId,
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.city) {
                    setCity(data)
                    return
                }
                setCity(null)
                return
                // // selectCity()
                // setCity(data)
                // setCityId(data.data.result.city[0]._id)
            })
    }
    const selectCity = async (slctCity) => {
        profileDetails({
            ...getProfileDetails,
            city: slctCity ? slctCity.target.value : cityId
        })
        const data = {
            "country": "",
            "state": "",
            "city": slctCity ? slctCity.target.value : cityId,
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {

            })
    }
    const couponEnter = (e) => {
        setCoupon((e.target.value).trimStart())
    }

    const RemoveCoupon = () => {
        if (coupon == '') {
            setpackagekey(2)
            setCoupon('')
            discountPercentage = 0
            calculatePrice(validity)
        }
        setCoupon('')
        setpackagekey(1)
        discountPercentage = 0
        calculatePrice(validity)
        showToastError('Coupon Removed Successful')
    }

    const addCoupon = async () => {
        setpackagekey(1)
        if (coupon == '' || coupon == undefined || coupon == null) {
            discountPercentage = 0
            calculatePrice(validity)
            setpackagekey(1)
            showToastError('Please Apply Any Coupon')
            return
            //  notificationService.show('Please Apply Any Coupon')
        }
        const data = {
            couponCode: coupon,
            packageId: subscription._id,
            validityId: validity._id,
        }
        await extendCoupon(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let req = JSON.parse(decrypt(data))
                if (req.data.code == 1) {
                    discountPercentage = req.data.result.discountPercentage
                    calculatePrice(validity)
                    showToast(req.data.message)
                    setpackagekey(2)
                }
                else {
                    showToastError(req.data.message)
                }
            })
    }

    const calculatePrice = async (validity) => {
        if (discountPercentage != 0) {
            packagePrice = validity?.mrp != null ? validity?.mrp : 0
            couponPrice = (packagePrice * discountPercentage) / 100
            packagePrice = packagePrice - couponPrice
            totalprice = packagePrice - redeem
            setCouponshow(couponPrice)
            settotalprice(packagePrice)
            setAmount((totalprice).toFixed(2))
        }
        else {
            packagePrice = validity?.mrp != null ? validity?.mrp : 0
            discountPercentage = 0
            couponPrice = 0
            totalprice = (packagePrice - redeem);
            settotalprice(packagePrice)
            setCouponshow(couponPrice)
            setAmount((totalprice).toFixed(2))
        }
    }

    const onSubmit = async (e) =>   // to submit  the form
    {
        e.preventDefault();
        if (!course?.collegeName) {
            showToastError('Please update your college details from the profile section')
            return
        }
        if (isBillingRequired && (getProfileDetails?.country == '' || getProfileDetails?.state == '' || getProfileDetails?.city == '')) {
            showToastError("Please Enter Shipping address")
        }
        else {

            if (getProfileDetails?.country != '') {
                country?.data?.result?.countries?.map((obj) => {
                    if (obj._id == getProfileDetails?.country) {
                        BillingCountry = (obj.title)
                    }
                })
            }
            if (getProfileDetails?.state != '') {
                state?.data?.result?.states?.map((obj) => {
                    if (obj._id == getProfileDetails?.state) {
                        Billingstate = (obj.title)
                    }
                })
            }
            if (getProfileDetails?.city != '') {
                city?.data?.result?.city?.map((obj) => {
                    if (obj._id == getProfileDetails?.city) {
                        Billingcity = (obj.title)
                    }
                })
            }

            const data = {
                "couponName": coupon,
                "currency": "INR",
                "packageExtensionValidityId": validity?._id,
                "packageId": subscription?._id,
                "packageType": 1,
                "purchaseType": "EXTENSION",
                // "validityId": subscription?.packagePurchased?.validityId,
                "billingAddress": {
                    "colonyArea": getProfileDetails?.colonyArea,
                    "city": Billingcity != undefined ? Billingcity : '',
                    "country": BillingCountry != undefined ? BillingCountry : '',
                    "flatNumber": getProfileDetails?.flateNumber,
                    "landmark": getProfileDetails?.landmark,
                    "pincode": getProfileDetails?.pincode,
                    "state": Billingstate != undefined ? Billingstate : '',
                    "fullAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
                },
                "shippingAddress": {
                    "colonyArea": getProfileDetails?.colonyArea,
                    "city": Billingcity != undefined ? Billingcity : '',
                    "country": BillingCountry != undefined ? BillingCountry : '',
                    "flatNumber": getProfileDetails?.flateNumber,
                    "landmark": getProfileDetails?.landmark,
                    "pincode": getProfileDetails?.pincode,
                    "state": Billingstate != undefined ? Billingstate : '',
                    "fullAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode
                },
            }
            // console.log(data,'wqeqwewqe');
            // return
            await CreateOrder(data)
                .then(response => {
                    return response.json()
                })
                .then((req) => {
                    if (req.success == true) {
                        paymentDetail = req?.data
                        setpaymentDetail(req.data)
                        razorpayDetails(e)
                    }
                    else if (req.success == false) {
                        showToastError(req.message)
                    }
                }).catch((err) => {
                    showToastError("Something went wrong please try agian")
                })
        }
    }
    const razorpayDetails = async (e) => {
        e.preventDefault()
        var options = {
            "key": process.env.REACT_APP_Razorpay_Key, // Enter the Key ID generated from the Dashboard
            "amount": TotalAmount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "eGurukul",
            "description": course?.name,
            "image": "https://rzp-mobile.s3.amazonaws.com/images/rzp.png",
            "order_id": paymentDetail?.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "capture": "0",
            "method": "all",
            "handler": (response) => {
                makeApiCall()
            },
            "prefill": {
                "name": course?.name,
                "email": course?.email,
                "contact": course?.mobileNo,
                "method": "All",
                "_[flow]": "intent",
                "upi_app_package_name": "com.phonepe.app",
                "prefill": "preFill"
            },
            // "notes": {
            //     "appOrderId": paymentDetail?.notes?.orderId,
            //     "mobileNo": course?.mobileNo,
            //     "packageDetails": "Package, " + subscription?.title + ',' + subscription?.packageCode,
            //     "billingAddress": getProfileDetails.flateNumber + "," + getProfileDetails.colonyArea + "," + getProfileDetails.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails.pincode,
            //     "college": course?.country + "," + course?.collegeState + ',' + course.collegeCity + ',' + course.collegeName,
            //     "invoiceNumber": paymentDetail?.notes?.invoiceNumber,
            //     "couponName": coupon != null ? coupon : '',
            //     "validity": validity,
            //     "month": validity?.vtype
            // },
            "theme": {
                "color": "#3AC3FF",
                "hide_topbar": "true",
                "theme": "theme"
            }
        };
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );
        let razorpay = new window.Razorpay(options);
        razorpay.open();
        razorpay.on('payment.failed', (response) => {
            makeApiCall()
        });
    }

    useEffect(() => {
        countryId && selectCountry()
    }, [countryId])

    useEffect(() => {
        stateId && selectState()
    }, [stateId])

    useEffect(() => {
        cityId && selectCity()
    }, [cityId])

    useEffect(() => {
        termList()
        getCountry()
    }, []);
    //  console.log(subscription,"subscription")
    return (
        <>
            <div className="main_wrapper">
                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><a >Home</a></li>
                        <li className="breadcrumb-item"><a >Subscription</a></li>
                        <li className="breadcrumb-item active"><a >Extention</a></li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper subscription_plans_wrapper section_side_padding">
                    <ToastContainer autoClose={500} limit={1} />
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="recommended_video_wrapper">
                                <div className="choose_plans_wrapper d-flex align-items-center">
                                    <figure className="arrow">
                                        <Link to={'/package'}>
                                            <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                        </Link>
                                    </figure>
                                    <div className="subscription_ttl">
                                        <h5>{packId?.title}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="plans_details_wrapper">
                                    <div className="plans_main_ttl">
                                        <h5>Term & Condition</h5>
                                    </div>
                                    <ul type="none" className="extention_terms_list">
                                        {
                                            <div dangerouslySetInnerHTML={{ __html: `${term && term?.packageExtensionContent?.packageExtensionContent}` }}></div>
                                        }

                                    </ul>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="plans_details_wrapper">
                                    <div className="plans_main_ttl">
                                        <h5>Choose Package</h5>
                                    </div>
                                    <div className="plans_packages d-flex flex-wrap">
                                        {
                                            subscription?.packageExtension && subscription?.packageExtension?.validity?.map((ob, i) => (
                                                <label for={`packageSelected${i}`}>
                                                    <input type="radio" id={`packageSelected${i}`} name="radioName" onClick={(e) => choosePackage(e, i, ob)} hidden />
                                                    <div className={`plans_info ${(packages == true && i == ind) ? 'selected' : ''}`}>
                                                        <span>{ob.number != null ? ob.number : 0}  {ob.vtype != '' ? ob.vtype : '1x'}</span>
                                                        <h6>&#8377; {ob.mrp != null ? ob.mrp : 0}</h6>
                                                    </div>
                                                </label>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                isCouponRequired &&
                                <div className="recommended_video_wrapper">
                                    <div className="plans_details_wrapper">
                                        <div className="plans_main_ttl">
                                            <h5>Enter Coupon Code</h5>
                                        </div>
                                        <div className="coupon_code">
                                            <div className="coupon_input d-flex align-item-center">
                                                <div className="code">
                                                    {
                                                        packagekey == 1 &&
                                                        <input type="text" className="form-control" placeholder="Write Here" value={coupon} onChange={(e) => couponEnter(e)} />
                                                    }
                                                    {
                                                        packagekey == 2 &&
                                                        <input type="text" className="form-control" placeholder="Write Here" value={coupon} disabled={true} onChange={(e) => couponEnter(e)} />
                                                    }
                                                </div>
                                                <div className="apply_btn">
                                                    {packagekey == 1 &&
                                                        <button type="button" className="btn btn_apply" onClick={addCoupon}>Apply <img src={Icons.ArrowBlue} alt="" className="img-fluid" /></button>
                                                    }
                                                    {
                                                        packagekey == 2 &&
                                                        <button type="button" className="btn btn_apply" onClick={RemoveCoupon}>Reset <img src={Icons.ArrowBlue} alt="" className="img-fluid" /></button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="form_submission">
                                <form onSubmit={(e) => { onSubmit(e) }}>
                                    {isBillingRequired &&
                                        <div className="recommended_video_wrapper">
                                            <div className="plans_details_wrapper">
                                                <div className="plans_main_ttl">
                                                    <h5>Shipping Address</h5>
                                                </div>
                                                <div className="billing_address">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Flat, House No., Building, Apartment*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'flateNumber')} value={getProfileDetails?.flateNumber} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Area, Colony, Street, Sector, Village*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'colonyArea')} value={getProfileDetails?.colonyArea} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Landmark" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'landmark')} value={getProfileDetails?.landmark} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="tel" className="form-control" id="" placeholder="Pincode*" maxlength="6" onChange={(e) => handleInputChange(((e.target.value).trimStart()).replace(/\D/g, ''), 'pincode')} value={getProfileDetails?.pincode} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectCountry(event)}>
                                                                    <option value="" selected >Select Country</option>
                                                                    {
                                                                        country && country.data.result.countries.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.country && getProfileDetails.country === d._id} >{d.title}</option>
                                                                        ))
                                                                    }
                                                                    {/* <option value="">India</option>
                                                            <option value="">India</option>
                                                            <option value="">India</option>
                                                            <option value="">India</option> */}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectState(event)}>
                                                                    <option value="" selected >Select State</option>
                                                                    {
                                                                        (state != null && state.data) && state.data.result.states.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.state && getProfileDetails.state === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                    {/* <option value="">Uttar Pradesh</option>
                                                            <option value="">Maharastra</option> */}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectCity(event)}>
                                                                    <option value="" selected >Select City</option>
                                                                    {
                                                                        (city && city.data) && city.data.result.city.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.city && getProfileDetails.city === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                    {/* <option value="">Kanpur</option>
                                                            <option value="">Lucknow</option> */}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        (packages == true) &&
                                        <div className="recommended_video_wrapper ">
                                            <div className="plan_price d-flex align-items-center justify-content-between">
                                                <h3>₹ {TotalAmount} <span onClick={orderInfo}>View Details <img src={Icons.OrderDetailInfo} alt="" className="img-fluid" /></span></h3>
                                                {
                                                    <button type="submit" className="btn btn_buy">Buy Now</button>
                                                }

                                            </div>
                                        </div>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Modal
                show={orderShow}
                onHide={orderHide}
                backdrop="static"
                className="detail_modal order_summary"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Order Summary <span>{subscription?.title}</span></h4>
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={orderHide} />
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="account_option_wrapper">
                        <div className="main_accrodion">
                            <div id="accordion">
                                <div className="vibe_dropdown_wrapper">
                                    <div className="vibe_header">
                                        <a className="card-link" data-toggle="collapse" href="#collapseTwo">
                                            <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                <div className="vibe_ttl">
                                                    <h6>Subscription Package</h6>
                                                </div>
                                                <div className="vibe_price">
                                                    <span>₹{Price}</span>
                                                </div>
                                            </div>
                                            <span className="down_arrow">
                                                <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                            </span>
                                        </a>
                                    </div>
                                    <div id="collapseTwo" className="collapse" data-parent="#accordion">
                                        <div className="price_body">
                                            <ul type="none">
                                                <li className="d-flex align-items-center justify-content-between">
                                                    <div className="vibe_amount">
                                                        <h6>Original Amount</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span>₹{validity?.mrp !== null ? validity?.mrp : 0}</span>
                                                    </div>
                                                </li>
                                                <li className="d-flex align-items-center justify-content-between">
                                                    <div className="vibe_amount">
                                                        <h6>Discounted Amount</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span className="green">-₹0.0</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="final_price">
                            <ul type="none">
                                {/* <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6>Coupon Discount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span>₹{couponshow}</span>
                                    </div>
                                </li> */}
                                {/* <li className="d-flex align-items-center justify-content-between">
                                <div className="vibe_amount">
                                    <h6>Coin Discount</h6>
                                </div>
                                <div className="vibe_price">
                                    <span>₹{redeemshow}</span>
                                </div>
                            </li> */}
                                <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6 className="green">Total Amount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span className="green">₹ {TotalAmount}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}